module.exports = __webpack_public_path__ + "static/media/bio-med-mobile.7cd11ec4.svg";